import type {CustomerScanContext} from "../scan-model/CustomerScanContext.tsx";
import type {ScanContext, SharedJobData} from "../../../analysis-process/3-perform-scan/scan-model/ScanContext.tsx";
import {scanSharedJobs} from "../../../analysis-process/3-perform-scan/scan-operations/1-ScanSharedJobs.tsx";
import type {SharedJobScanResult} from "../../../analysis-process/3-perform-scan/scan-model/SharedJobResult.ts";

/**
 * Adapter to scan shared jobs using the customer scan context
 * Returns both the scan result and a map of shared jobs by implementation ID
 */
export async function scanCustomerSharedJobs(ctx: CustomerScanContext): Promise<{
    result: SharedJobScanResult
    sharedJobsMap: Record<number, SharedJobData>
}> {
    // Create an adapter context that includes the sharedJobs map
    const sharedJobsMap: Record<number, SharedJobData> = {}
    
    const adaptedContext: ScanContext = {
        ...ctx,
        sharedJobs: sharedJobsMap,
        options: {
            ...ctx.options,
            // Map fields for scanSharedJobs
            analyseProjects: ctx.options.selectedProjects,
            analyseSchedules: false,
            analyseSharedJobs: false, // We don't do deep analysis for customer workloads
            sharedJobRunner: ctx.options.jobDownloadRunner,
            analyseDrivers: false,
            analyseTaskHistory: ctx.options.analyseTaskHistory,
            analyseCredentials: false,
            analyseWebhooks: false,
            analyseApiProfiles: false,
            analyseOauthConnections: false,
            analysePasswords: false,
            analyseGit: false,
            analyseQueueConfig: false
        }
    }
    
    const result = await scanSharedJobs(adaptedContext)
    
    return {
        result,
        sharedJobsMap
    }
}
